import { http } from "./http";

// WebSocket URL - keep this separate
const WS_BASE = process.env.REACT_APP_WS_BASE || "ws://localhost:5001";

/**
 * 🔹 POS Customer APIs
 */

// Search for POS customers by phone or name
export const searchPOSCustomers = async (query: string) => {
  const response = await http.get("/pos/customers/search", {
    params: { query },
  });
  return response.data;
};

// Create a new POS customer
export const createPOSCustomer = async (customerData: {
  name: string;
  phone: string;
  email?: string;
}) => {
  const response = await http.post("/pos/customers/create", customerData);
  return response.data;
};

/**
 * 🔹 POS Order APIs
 */

// Create a new POS order
export const createPOSOrder = async (orderData: {
  customer_id?: number;
  customer_name: string;
  store_id: number;
  items: { product_id: number; variant_id: number; quantity: number }[];
  discount: { type: string; value: number };
  payment: {
    method: string;
    amount: number;
    cash_received: number;
    store_credit_used?: number;
    loyalty_points_redeemed?: number;
  };
}) => {
  try {
    const response = await http.post("/pos/orders/create", orderData);
    return response.data;
  } catch (error) {
    console.error("Error creating POS order:", error);
    throw error;
  }
};

// Process POS payment
export const processPOSPayment = async (paymentData: {
  order_id: number;
  payment_method: string;
  amount: number;
  cash_received?: number;
  store_credit_used?: number;
  loyalty_points_redeemed?: number;
  store_id: number;
}) => {
  console.log("🔄 Sending POS Payment Request:", paymentData);

  try {
    const response = await http.post("/pos/orders/payment", paymentData);
    console.log("✅ Payment API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Payment API Error:", error);
    throw error;
  }
};

/**
 * 🔹 POS Loyalty APIs
 */

// Get customer loyalty balance
export const getPOSCustomerLoyalty = async (customerId: number, storeId: number) => {
  if (!storeId) {
    console.error("Store ID is missing!");
    throw new Error("Store ID is required");
  }

  const response = await http.get(`/pos/loyalty/${customerId}/${storeId}`);
  return response.data;
};

// Get loyalty settings (Admin Only)
export const getLoyaltySettings = async () => {
  const response = await http.get("/pos/loyalty/settings");
  return response.data;
};

// Update loyalty settings (Admin Only)
export const updateLoyaltySettings = async (percentage: number) => {
  const response = await http.post("/pos/loyalty/settings", { percentage });
  return response.data;
};

// 🔹 Process Clover Payment (Credit/Debit Card Transactions)
export const processCloverPayment = async (paymentData: {
  order_id: number;
  amount: number;
  store_id: number;
  customer_id?: number;
  card_type: "credit" | "debit";
}) => {
  console.log("💳 Sending Clover Payment Request:", paymentData);

  try {
    const response = await http.post("/pos/clover/pay", paymentData);
    console.log("✅ Clover Payment Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Clover Payment API Error:", error);
    throw error;
  }
};

// Clover OAuth API
export const initiateCloverOAuth = async () => {
  const response = await http.get("/clover/initiate");
  return response.data;
};

export const checkCloverOAuthStatus = async (merchantId: string) => {
  const response = await http.get("/clover/status", {
    params: { merchant_id: merchantId },
  });
  return response.data;
};

export const processCloverRestPayment = async (order_id: number, amount: number) => {
  const response = await http.post("/pos/orders/clover-rest-pay", { order_id, amount });
  return response.data;
};